export const isStep1EvaluationComplete = (row = {}) =>
  [row?.eval_id, row?.frequency_id, row?.importancy_id].every((value) => Number(value) > 0);

export const isStep1RowComplete = (row = {}) => {
  if (!row?.__lineGroup) return isStep1EvaluationComplete(row);
  const items = Array.isArray(row.items) ? row.items : [];
  return items.length > 0 && items.every(isStep1EvaluationComplete);
};
